module.exports = __webpack_public_path__ + "img/ggA_ElbeSaale.7e6b94e5.png";